module.exports = __webpack_public_path__ + "img/1kDmFdayzrjKV9HZM99k4zFKSxGA9vHKY.0da917cd.png";